import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Environment{
    constructor(){
        //console.log("Environment Class")
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug

        //Debug
        // if(this.debug.active){
        //     this.debugFolder = this.debug.ui.addFolder("environment")
        // }
        this.setAmbientLight()
        this.setSunLight()
        //this.setContactDirectionalLight()
        //this.setContactSpotLight()
        this.setStarfield()
        this.setStarsGeometry()
        this.setStarsMaterial()
        this.setStarfieldMesh()
        //this.setEnvironmentMap()
    }

    setAmbientLight(){
        this.ambientLight = new THREE.AmbientLight(0xffffff, 0.15)
        this.scene.add(this.ambientLight)
    }

    setSunLight(){
        this.sunLight = new THREE.PointLight(0xffffcc, 4000, 500)
        this.sunLight.castShadow = true
        this.sunLight.shadow.mapSize.width = 1024
        this.sunLight.shadow.mapSize.height = 1024
        this.sunLight.shadow.camera.near = 0.1
        this.sunLight.shadow.camera.far = 150
        this.sunLight.position.set(0, 0, 0)
        this.scene.add(this.sunLight)

        // Debug
        // if(this.debug.active){
        //     this.debugFolder
        //         .add(this.sunLight, "intensity")
        //         .name("sunLightIntensity")
        //         .min(0)
        //         .max(10)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.sunLight.position, "x")
        //         .name("sunLightX")
        //         .min(-5)
        //         .max(5)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.sunLight.position, "y")
        //         .name("sunLightY")
        //         .min(-5)
        //         .max(5)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.sunLight.position, "z")
        //         .name("sunLightZ")
        //         .min(-5)
        //         .max(5)
        //         .step(0.001)
        // }
    }

    setContactSpotLight(){
        this.contactSpotLight = new THREE.SpotLight(0xffffff, 2000,100,Math.PI * 0.1,1,2)
        this.contactSpotLight.position.set(0,0,0)
        this.contactSpotLight.castShadow = true
        this.contactSpotLight.shadow.mapSize.width = 1024
        this.contactSpotLight.shadow.mapSize.height = 1024
        this.contactSpotLight.shadow.radius = 1

        this.contactSpotLightTarget = new THREE.Object3D()
        this.contactSpotLightTarget.position.set(10, 0, -10)
        this.scene.add(this.contactSpotLightTarget)

        this.contactSpotLight.target = this.contactSpotLightTarget

        this.scene.add(this.contactSpotLight)

        this.spotLightHelper = new THREE.SpotLightHelper(this.contactSpotLight)
        this.scene.add(this.spotLightHelper)
        
    }

    setContactDirectionalLight(){
        this.dirTarget = new THREE.Object3D()
        this.dirTarget.position.set(-1, 0, -1)
        
        this.scene.add(this.dirTarget)
        this.contactDirectionalLight = new THREE.DirectionalLight(0xffffcc, 0.5)
        this.contactDirectionalLight.target = this.dirTarget
        this.scene.add(this.contactDirectionalLight)

        const helper = new THREE.DirectionalLightHelper(this.contactDirectionalLight, 5)
        this.scene.add(helper)
    }

    setStarfield(){
        this.starCount = 10000
        this.minRadius = 127
        this.maxRadius = 300
        this.starsGeo = new THREE.BufferGeometry()
        this.positions = new Float32Array(this.starCount * 3)
        for(let i = 0; i < this.starCount; i++){
            this.theta = Math.random() * 2 * Math.PI // Horizontal angle
            this.phi = Math.acos(2 * Math.random() - 1) // vertical angle
            this.radius = Math.cbrt(Math.random()) * (this.maxRadius - this.minRadius) + this.minRadius
            // this.positions[i * 3] = (Math.random() - 0.5) * 1000
            // this.positions[i * 3 + 1] = (Math.random() - 0.5) * 1000
            // this.positions[i * 3 + 2] = (Math.random() - 0.5) * 1000
            this.positions[i * 3] = this.radius * Math.sin(this.phi) * Math.cos(this.theta)
            this.positions[i * 3 + 1] = this.radius * Math.sin(this.phi) * Math.sin(this.theta)
            this.positions[i * 3 + 2] = this.radius * Math.cos(this.phi)
        }
    }

    setStarsGeometry(){
        this.starsGeo.setAttribute('position', new THREE.BufferAttribute(this.positions, 3))
    }

    setStarfieldMesh(){
        this.starfieldMesh = new THREE.Points(this.starsGeo, this.startsMaterial)
        this.scene.add(this.starfieldMesh) 
    }

    setStarsMaterial(){
        this.startsMaterial = new THREE.PointsMaterial({
            color: 0xffffff,
            size: 1,
            sizeAttenuation: true,
            map: this.resources.items.starAlpha,
            //transparent: true,
            //alphaTest: 0.01,
            depthWrite: false,
            blending: THREE.AdditiveBlending,
        })
        //console.log(this.resources.items.starAlpha)
    }

    setEnvironmentMap(){
        this.environmentMap = {}
        this.environmentMap.intensity = 0.4
        this.environmentMap.texture = this.resources.items.environmentMapTextureStars // must match name exactly in sources.js
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace
        //this.scene.environment = this.environmentMap.texture // make texture be the lighting environment?
        //this.scene.background = this.environmentMap.texture // Make texture visible
        // prevents potential bug of env map not being applied to materials
        this.environmentMap.updateMaterials = () =>{
            this.scene.traverse((child)=>{
                //console.log(child)
                //This could mess with custom shaders but i don't think i'm using the env texture as a light source
                if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial){
                    child.material.envMap = this.environmentMap.texture
                    child.material.envMapIntensity = this. environmentMap.intensity
                    child.material.needsUpdate = true
                }
            })
        }
        this.environmentMap.updateMaterials()

        //Debug
        // if(this.debug.active){
        //     this.debugFolder
        //         .add(this.environmentMap, "intensity")
        //         .name("envMapIntensity")
        //         .min(0)
        //         .max(4)
        //         .step(0.001)
        //         .onChange(this.envronmentMap.updateMaterials)
        // }
    }

}